import Loading from './Loading'

type PageLoadingProps = {
  minHeightClassName?: string
}

const DEFAULT_MIN_HEIGHT = 'min-h-[calc(100vh-64px)]'

const PageLoading = ({ minHeightClassName = DEFAULT_MIN_HEIGHT }: PageLoadingProps) => {
  return (
    <div className={`${minHeightClassName} w-full bg-imovWhiteShadow flex items-center justify-center`}>
      <Loading className="p-0" />
    </div>
  )
}

export default PageLoading
